import type { Translations } from '../i18n';
import en from './translations.json';

export default {
  en,
} as Record<string, Translations>;
